import { render, staticRenderFns } from "./OrderAddress.vue?vue&type=template&id=77d21058&"
import script from "./OrderAddress.vue?vue&type=script&lang=js&"
export * from "./OrderAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports